import { BoardLayout } from "@/components/board/BoardLayout";
import { ApiKeysSettings } from "@/components/settings/ApiKeysSettings";
import { AppSettings } from "@/components/settings/AppSettings";
import { SettingsAccessTable } from "@/components/settings/SettingsAccessTable";
import { SettingsTabs, type SettingsTab } from "@/components/settings/SettingsTabs";
import { UserSettings } from "@/components/settings/UserSettings";
import { useQueryParams } from "@/hooks/useQueryParams";
import { AuditLogView } from "@/pages/audit-log";

const SETTINGS_TABS = new Set<SettingsTab>(["access", "app", "user", "api-keys", "audit"]);

function parseSettingsTab(value: string | null): SettingsTab {
  return value && SETTINGS_TABS.has(value as SettingsTab) ? (value as SettingsTab) : "app";
}

export default function Settings() {
  const { get, setParam } = useQueryParams();
  const tab = parseSettingsTab(get("tab"));

  const handleTabChange = (nextTab: SettingsTab) => {
    setParam("tab", nextTab === "app" ? null : nextTab);
  };

  return (
    <BoardLayout>
      <div className="settings-page">
        <SettingsTabs active={tab} onChange={handleTabChange} />
        {tab === "access" ? (
          <SettingsAccessTable />
        ) : tab === "api-keys" ? (
          <ApiKeysSettings />
        ) : tab === "user" ? (
          <UserSettings />
        ) : tab === "audit" ? (
          <AuditLogView />
        ) : (
          <AppSettings />
        )}
      </div>
    </BoardLayout>
  );
}
